import { Spin } from "antd";
import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { getCurrentUser } from "./utils/helper";

const Landing = React.lazy(() => import("./screens/landing"));
const FreeTrial = React.lazy(() => import("./screens/free-trial"));
const ThanksForFreeTrial = React.lazy(() => import("./screens/free-trial/thanks"));
const RequestDemo = React.lazy(() => import("./screens/request-demo"));
const ThanksForRequestDemo = React.lazy(() => import("./screens/request-demo/thanks"));
const TermsAndConditions = React.lazy(() => import("./screens/terms-and-conditions"));
const AdminLogin = React.lazy(() => import("./screens/admin-login"));
const AllBlogs = React.lazy(() => import("./screens/new-blogs"));
const Blogs = React.lazy(() => import("./screens/blogs"));
const BlogDetailView = React.lazy(() => import("./screens/blogs/detail-view"));

const ProtectedRoute = ({ children }) => {
  const currentUser = getCurrentUser;
  return currentUser ? children : <Navigate to="/admin-login" replace />;
};

function App() {
  return (
    <Suspense
      fallback={
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/home" element={<Landing />} />
        <Route path="/free-trial" element={<FreeTrial />} />
        <Route path="/free-trial-thanks" element={<ThanksForFreeTrial />} />
        <Route path="/request-demo" element={<RequestDemo />} />
        <Route path="/request-demo-thanks" element={<ThanksForRequestDemo />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog-detail" element={<BlogDetailView />} />

        <Route
          path="/blogs/all"
          element={
            <ProtectedRoute>
              <AllBlogs />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
}

export default App;
